/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCloudAccount {
    getFixupPrototypeFunction() { return AwsSsmCloudAccount.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCloudAccount>): AwsSsmCloudAccount {
        let obj = Object.assign(new AwsSsmCloudAccount(), model);
        AwsSsmCloudAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCloudAccount>): AwsSsmCloudAccount {
        if (!model) return null;
        return AwsSsmCloudAccount.newInstance(<AwsSsmCloudAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCloudAccount) {
        if (!obj) return;

        models.AwsSsmCloudAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCloudAccount): boolean {
        Object.setPrototypeOf(obj, AwsSsmCloudAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.sync_status) {
            models.AwsSsmCloudAccountSyncDetails.fixupPrototype(this.sync_status);
        }
    }

    /**
     * Id of the cloud account.
     */
    id: string;

    /**
     * Name of the cloud account.
     */
    name: string;

    sync_status: models.AwsSsmCloudAccountSyncDetails;

}
